import React from "react";
import {
    XBrowseProps,
    XLazyColumn,
    XLazyDataTable
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {Utils} from "../../Utils";
import {EnumEnum} from "../../common/enums";
import {XtDocTemplateForm} from "./XtDocTemplateForm";

export const XtDocTemplateBrowse = (props: XBrowseProps) => {

    const onAddRow = () => {

        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<XtDocTemplateForm/>);
    }

    const onEdit = (selectedRow: any) => {

        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<XtDocTemplateForm id={selectedRow.id}/>);
    }

    return (
        <div>
            <XLazyDataTable entity="XtDocTemplate" label="Doc templates" rows={30} sortField="label"
                            onAddRow={onAddRow} onEdit={onEdit} removeRow={true}
                            displayed={props.displayed} multilineSwitch={true}>
                <XLazyColumn field="id" header="ID" width="5rem"/>
                <XLazyColumn field="label" header="Label" width="12rem"/>
                <XLazyColumn field="comment" header="Comment" width="20rem"/>
                <XLazyColumn field="entity" header="Entity" width="12rem"/>
                <XLazyColumn field="typPristupuSluzba.name" header="Typ prístupu" width="9rem" dropdownInFilter={true} dropdownFilter={Utils.enumFilter(EnumEnum.typPristupuSluzba)}/>
                <XLazyColumn field="sluzbaList.nazov" header="Služby" width="12rem" dropdownInFilter={true}/>
                <XLazyColumn field="templateId" header="Template ID" width="8rem"/>
                <XLazyColumn field="templateXFile.name" header="Template file" width="15rem"/>
                <XLazyColumn field="availableInForms" header="Available in forms"/>
            </XLazyDataTable>
        </div>
    );
}
